import React from "react";
import PropTypes from "prop-types";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Link, withRouter } from "react-router-dom";
import { createRef } from "react";
import { Container } from "react-bootstrap";

import Toast from "services/Toast";
import Emitter from "services/Emitter";
import MerchantService from "services/MerchantService";
import MyTable from "components/MyTable";
import Utils from "services/Utils";

/**
 * @component
 * @category Scenes
 * @subcategory Merchant
 */
class Trends extends React.Component {
    constructor(props) {
        super(props);
        this.onEnter = this.onEnter.bind(this);
        this.tableRef = createRef();
        this.state = {
            days: ["...", "...", "...", "...", "...", "...", "..."],
        };
    }

    componentDidMount() {
        Emitter.on("MERCHANT_TRENDS", this.onEnter);
        Emitter.on("MERCHANT_RESET", () => {
            this.setState(this.initialState());
        });
    }

    componentWillUnmount() {
        Emitter.off("MERCHANT_TRENDS");
        Emitter.off("MERCHANT_RESET");
    }

    onEnter() {
        if (this.state.id === this.props.merchantId) {
            return;
        }

        MerchantService.trends(this.props.merchantId).then((data) => {
            if (data === false) {
                Toast.error(
                    "Something went wrong while loading the list of products"
                );
                return;
            }
            let list = [];
            let keys = Object.keys(data.items.brands);
            keys.forEach((brand_id) => {
                let row = data.items.brands[brand_id];
                list.push({
                    id: brand_id,
                    name: row.name,
                    products: row.products,
                    day0: row.diff[0],
                    day1: row.diff[1],
                    day2: row.diff[2],
                    day3: row.diff[3],
                    day4: row.diff[4],
                    day5: row.diff[5],
                    day6: row.diff[6],
                    sum:
                        row.diff[1] +
                        row.diff[2] +
                        row.diff[3] +
                        row.diff[4] +
                        row.diff[5] +
                        row.diff[6],
                });
            });

            this.setState({ days: data.items.days }, () => {
                this.tableRef.current?.populate(list);
            });
        });
    }

    render() {
        return (
            <Container className="pt-4">
                <MyTable
                    name="merchant-trends"
                    dynamic={false}
                    ref={this.tableRef}
                    sortBy="sum"
                    sortOrder="asc"
                    headers={[
                        {
                            field: "name",
                            label: "Brand",
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day0",
                            width: "80px",
                            hint: "Reference date",
                            label: this.state.days[0],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day1",
                            width: "80px",
                            hint: `Variation between ${this.state.days[0]} and ${this.state.days[1]}`,
                            label: this.state.days[1],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day2",
                            width: "80px",
                            hint: `Variation between ${this.state.days[1]} and ${this.state.days[2]}`,
                            label: this.state.days[2],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day3",
                            width: "80px",
                            hint: `Variation between ${this.state.days[2]} and ${this.state.days[3]}`,
                            label: this.state.days[3],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day4",
                            width: "80px",
                            hint: `Variation between ${this.state.days[3]} and ${this.state.days[4]}`,
                            label: this.state.days[4],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day5",
                            width: "80px",
                            hint: `Variation between ${this.state.days[5]} and ${this.state.days[6]}`,
                            label: this.state.days[5],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "day6",
                            width: "80px",
                            hint: `Variation between ${this.state.days[5]} and ${this.state.days[6]}`,
                            label: this.state.days[6],
                            sortable: true,
                            searchable: true,
                        },
                        {
                            field: "sum",
                            label: "Sum",
                            width: "80px",
                            hint: "Cumulative variation over the last week",
                            sortable: true,
                            searchable: true,
                        },
                    ]}
                    renderColumns={{
                        name: (row) => (
                            <Link
                                key={`link-brand-${row.id}`}
                                className="link"
                                to={`/brand/${row.id}`}
                            >
                                (#{row.id}) {row.name}
                            </Link>
                        ),
                        day0: {
                            className: "gray",
                            format: (row) => (row.day0 ? row.day0 : ""),
                        },
                        day1: (row) => Utils.trendColumn(row, "day1"),
                        day2: (row) => Utils.trendColumn(row, "day2"),
                        day3: (row) => Utils.trendColumn(row, "day3"),
                        day4: (row) => Utils.trendColumn(row, "day4"),
                        day5: (row) => Utils.trendColumn(row, "day5"),
                        day6: (row) => Utils.trendColumn(row, "day6"),
                        sum: (row) => Utils.trendColumn(row, "sum"),
                    }}
                />
            </Container>
        );
    }
}

Trends.propTypes = {
    /** Merchant ID */
    merchantId: PropTypes.number.isRequired,
};

export default withRouter(Trends);
